import type { FirebaseApp } from 'firebase/app';
import type { User } from 'firebase/auth';
import type { Messaging } from 'firebase/messaging';
import { writable } from 'svelte/store';

export const firebaseStore = writable<FirebaseApp>(null);
export const firebaseAuthStore = writable<{
  user: User;
  loading: boolean;
}>({
  user: null,
  loading: true
});

export const firebaseMessagingToken = writable<string>(null);
export const firebaseMessaging = writable<Messaging>(null);
